import React, { Component } from "react";
import AuthTopNav from "../containers/TopNav/AuthTopNav";
import Footer from "../containers/Footer";
import MobileNavbar from "../containers/MobileNavbar";
import "../styles/_calendar.scss";
import CreateCircle from "../containers/NewCircle";

class NewCircle extends Component {
  queryParams=()=>{
    return new URLSearchParams(this.props.location.search);
  }

  query = this.queryParams();

  render() {
    return (
      <div className="app-wrapper has-mobile-navbar">
        <AuthTopNav />
        <section className="gray-bg">
          <div className="main-container">
            <div className="content-wrapper new-circle-standalone">
              <CreateCircle  reference={this.query.get('ref')}  />
            </div>
          </div>
        </section>
        <MobileNavbar />
        <Footer />
      </div>
    );
  }
}

export default NewCircle;
